module.exports = __webpack_public_path__ + "img/monochrome.763528de.png";